<template>
  <div class="bg-white">

    <el-table
      :data="shenheList"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号">
      </el-table-column>
      <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
      <el-table-column label="楼号" prop="building_name"></el-table-column>
      <el-table-column label="单元" prop="element_name"></el-table-column>
      <el-table-column label="房间" prop="room_name"></el-table-column>
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="phone"></el-table-column>
      <el-table-column width="150" label="申请时间" prop="add_time"></el-table-column>
      <el-table-column width="300" label="操作">
        <template slot-scope="scope">
          <div class="table-operate">

              <el-button
                size="small"
                type="success"
                @click="passItem(scope.row.id)"
              >通过
              </el-button>

            <el-button
                size="small"
                type="primary"
                @click="refuseItem(scope.row.id)"
              >驳回
              </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="shenheList.length > 0"
      class="page-all"
      background
      @current-change="getFileList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

  </div>
</template>

<script>
import {zhDate} from "@/utils/utils";
import {getShenheList, getShenheNo,getShenheYes} from "@/api/weilao";

export default {
  name: "server-shen",
  data() {
    return {
      shenheList:[],
      page: 1,
      limit: 10,
      total: 0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "老人认证申请审核", false);
    this.getShenList()
  },
  computed:{
    user() {
      return this.$store.state.user
    },
  },
  components: {

  },
  methods: {
    passItem(id) {
      this.$confirm('您确定要通过吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.surePass(id);
      });
    },
    async surePass(id) {
      let _state = await getShenheYes(id);
      if (this.shenheList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getShenList();
      this.$message.success(_state.info);
    },

    //  拒绝文件
    refuseItem(id) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
      }).then(({ value }) => {
        this.sureRefuse(id,value);
      })
    },
    async sureRefuse(id,str) {
      let _state = await getShenheNo(id,str);
      if (this.shenheList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getShenList();
      this.$message.success(_state.info);
    },

    //  获取文件列表
    async getShenList() {
      let _list = await getShenheList( this.page, this.limit)
      _list.data.map(item => {
        item.update_time = zhDate(item.create_time * 1000)
      })
      this.shenheList = _list.data
      this.total = _list.total_number
      if(_list.status === 800 )  this.shenheList =[]
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
